module.exports = __webpack_public_path__ + "img/ic_industry.4062bc90.svg";